import { UserType } from '../constants';

const initial = {
  userId: '',
  userData: {
    firstName: '',
    lastName: '',
    mobileNumber: '',
    emailId: '',
    groups: [],
    roles: [],
    realm: process.env.REACT_APP_REALM,
    userType: UserType.EMPLOYEE,
  },
};

export default (state = initial, event) => {
  switch (event.type) {
    case 'USER_ADD':
      return {
        ...state,
        userData: event.data.userData,
        userId: event.data.userId,
      };
    default:
      return state;
  }
};
